<template>
  <v-app id="inspire">
    <my-header />
    <v-main>
      <v-parallax height="300" src="../public/back2.jpg" />
      <v-container>
        <v-row justify="center" class="mt-n16">
          <v-col cols="12" sm="9" class="mt-n16">
            <v-card
              class="justify-center mt-n16 pb-16 rounded-lg"
              elevation="20"
            >
            <transition name="fade" mode="out-in">
              <router-view class="pt-16"></router-view>
            </transition>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <my-footer class="mt-16" />
  </v-app>
</template>

<script>
import MyFooter from "./components/MyFooter";
import MyHeader from "./components/MyHeader.vue";

export default {
  components: {
    MyFooter,
    MyHeader
  },
  data: () => ({
    drawer: false,
    switch1: false,
    theme: { light: true }
  })
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=PT+Serif&display=swap");
#inspire {
  font-family: "PT Serif", sans-serif;
}
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}
</style>
